import React from 'react';
import { withStyles, Button } from '@material-ui/core';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
    marginTop: '8px',
    color: theme.palette.getContrastText('#0098DA'),
    backgroundColor: '#0098DA',
    '&:hover': {
      backgroundColor: '#007db3'
    }
  }
});

export default withStyles(styles)(props => {
  const { classes } = props;

  return (
    <Button
      className={classes.button}
      size={'large'}
      variant={'contained'}
      color={'primary'}
      onClick={() => props.onClick()}
      disabled={props.disabled}
      style={props.style}
    >
      {props.text}
    </Button>
  );
});
